import * as React from "react";

export interface NullComponentProps {}

const NullComponent: React.FC<NullComponentProps> = ({ children }) => (
  <>{children}</>
);

export default NullComponent;
